import { Fragment, useEffect, useState } from "react";
import GridColumn from "@react/structure/GridColumn";
import Cards from "@react/widget/Card";
import { H2 } from "@react/widget/Headline";
import Img from "@react/widget/Img";
import Button from "@react/widget/Button";
import { translateGlossaries as ts } from "@i18next/client/utils";

interface CaseStudyFieldDetails {
  location: string;
  logo: Array<Image>;
  customerWebsite: string;
};
interface CaseStudy {
  siteHandle: string;
  sectionHandle: string;
  typeHandle: string;
  title: string;
  uri: string;
  url: string;
  caseStudy: Array<CaseStudyFieldDetails>;
};

interface Props {
  entries?: Array<CaseStudy>;
  glossaries?: Record<string, string>;
}

export default function App({entries = [], glossaries: gs }:Props) {
  const [caseStudies, setCaseStudies] = useState<Array<CaseStudy>>([]);
  const [page, setPage] = useState<number>(0);
  const [more, setMore] = useState(entries.length > 6);
  const limit = 6;

  const renderPage = (p:number) => {
    const start = p * limit,
      end = p * limit + limit;
    setPage(p);
    setMore(entries.length > end);
    setCaseStudies(entries.slice(0, end));
  }

  useEffect(() => {
    renderPage(page);
  }, [entries]);

  if(!entries || entries.length < 1)
    return <Fragment/>

  return (
    <div className="border-t py-8 space-y-6">
      <H2 size="xl">{ts(gs, "Trusted world-wide by these great organizations and many more!")}</H2>
      <GridColumn className='[&>div]:justify-center' columnNum="3-sm">
        {caseStudies.map(caseStudy => caseStudy.caseStudy.map(({ logo: [logo] = []}) => {
          return logo && (<Cards key={logo?.title} structure="center" border>
            <Img data={logo} width={163} height={69} fit="outside"/>
          </Cards>);
        }))}
      </GridColumn>
      { more && <Button onClick={() => renderPage(page + 1)}>{ts(gs, "More")}</Button> }
    </div>
  );
}